import { CardProps } from './Card';

const CardTheme = {
  baseStyle: ({ as, withHover }: CardProps) => {
    return {
      _focusVisible: {
        boxShadow: 'outline',
      },
      _hover:
        as === 'a' || as === 'button' || withHover
          ? {
              backgroundColor: 'neutral.95',
              borderColor: 'neutral.90',
            }
          : undefined,
      backgroundColor: 'neutral.100',
      border: '1px solid',
      borderRadius: '8',
      display: 'block',
      width: '100%',
    };
  },
  variants: {
    elevated: {
      borderColor: 'neutral.93',
      boxShadow: 'medium',
    },
    outline: {
      borderColor: 'neutral.90',
      boxShadow: 'none',
    },
  },
};

export default CardTheme;
